export type InventoryEventSettings = {
  listingCost: boolean;
  openListings: boolean;
  openTickets: boolean;
  lastSaleDate: boolean;
};

export const INVENTORY_EVENT_SETTINGS_STORAGE_KEY = 'inventory-grid-event-settings';

export const DEFAULT_INVENTORY_EVENT_SETTINGS: InventoryEventSettings = {
  listingCost: true,
  openListings: true,
  openTickets: true,
  lastSaleDate: false,
};

export const INVENTORY_EVENT_SETTINGS_ITEMS: { key: keyof InventoryEventSettings; name: string }[] = [
  { key: 'listingCost', name: 'Listing Cost' },
  { key: 'openListings', name: 'Open Listings' },
  { key: 'openTickets', name: 'Open Tickets' },
  { key: 'lastSaleDate', name: 'Last Sale Date' },
];

export const normalizeInventoryEventSettings = (settings: Partial<InventoryEventSettings> | null | undefined): InventoryEventSettings => ({
  ...DEFAULT_INVENTORY_EVENT_SETTINGS,
  ...settings,
});
